import React from 'react';

import { Redirect, Route } from 'react-router-dom';

import { useCurrentUser } from 'providers/user/UserContext';
import { useFirebase } from 'providers/firebase/FirebaseContext';


/**
 * Mirrors the hasName() logic in UnauthRoute — accepts data.name.first,
 * data.displayName, data.firstName, or any profile with a type field.
 */
function hasName(data) {
    if (!data) return false;
    if (data.name && data.name.first && data.name.first.length > 0) return true;
    if (data.displayName && data.displayName.trim().length > 0) return true;
    if (data.firstName && data.firstName.trim().length > 0) return true;
    return typeof data.type === 'string' && data.type.length > 0;
}

export default function PrivateRoute({ children, ...rest }) {

    const { loading, data } = useCurrentUser();
    const firebase = useFirebase();

    const userHasFirstName = () => hasName(data);

    const render = ({ location }) => {
        // Wait for the auth + profile state to be resolved before routing.
        // This prevents a premature redirect to /login during the brief window
        // where the user is authenticated but the Firestore profile has not
        // yet been fetched (especially common right after sign-up).
        if (loading) {
            return null;
        }

        // If user is authenticated but email is not verified, send to verification page
        const authUser = firebase.auth.currentUser;
        if (data && authUser && !authUser.emailVerified) {
            return (
                <Redirect
                    to={{
                        pathname: "/verify-email",
                        state: { from: location }
                    }}
                />
            );
        }

        if (data && (userHasFirstName() || location.pathname === '/profile')) {
            return (
                children
            )
        } else if (data) {
            return (
                <Redirect
                    to={{
                        pathname: "/profile",
                        state: { from: location }
                    }}
                />
            )
        } else {
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: { from: location }
                    }}
                />
            )
        }
    };

    return (
        <Route
            {...rest}
            render={render}
        />
    );
};